<div class="madar--v2">
  <app-row class="py-2">
    <app-col cols="auto">
      <div class="flex" (click)="onSelectAll()">
        <button mat-button class="p-2 bg-accent-lighter btn--xsmall" color="accent">
          <app-icon name="add-square" class=" " size="xs"></app-icon>
        </button>
        <div class="h6 m-0 pl-2 text-accent weight-semibold cursor-pointer">
          {{'sharedFeatures.UndetailedOrders.AllOrdersWithCount' | translate:({count: ordersNo}) }}
        </div>
      </div>
    </app-col>
    <app-col cols="auto" class="ml-auto">
      <span class="small text-400 pr-2">{{'sharedFeatures.UndetailedOrders.PalletsWithCount' | translate:({count: palletsNo}) }}</span>
      <span class="small text-400">{{'sharedFeatures.UndetailedOrders.ItemsWithCount' | translate:({count: itemsNo}) }}</span>
    </app-col>
  </app-row>

  <mat-divider></mat-divider>
  <div class="scrollable scrollable--y" style="max-height: 52.5vh; overflow-x: hidden">
    <ng-container *ngFor="let order of orders; let i = index; let isLast = last">
      <app-orders-list-item
        *ngIf="!order.selected"
        [index]="i + 1"
        [order]="order.order"
        [selected]="order.selected"
        [totalCount]="order.order?.actualNoOfPallets"
        [selectedPalletsCount]="order.selectedPalletsCount || 0"
        (selectQuantity)="onSelectQuantity(order, $event)"
      ></app-orders-list-item>
      <mat-divider *ngIf="!isLast"></mat-divider>
    </ng-container>
  </div>
</div>
